import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';


//Componentes Atentus
//import ActiveObjectives from './components/ActiveObjectives';
//import InactiveObjectives from './components/InactiveObjectives';
import Quick from '../Dashboard/components/QuickView';
import UserNotification from '../Dashboard/components/UserNotification';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
// Component styles
const styles = theme => ({
    root: {
        "& .MuiPaper-root": {
            borderColor: '#fff'
        },
        padding: theme.spacing(2),
        backgroundColor: '#fff',
        height: '100%',
    },
    item: {
        height: '100%'
    }
});

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            objectivesList: {},
            Graph:1
        } 
    }
    myCallback = (dataFromChild) => {

        this.setState({
            objectivesList: dataFromChild
        })
    }

    render() {
        const { classes } = this.props;
        const { objectivesList } = this.state
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        return (
            <div>
                <UserNotification />
                <DashboardLayout title={t('dashboard-layout.title.operational-state')} callbackFromParent={this.myCallback} isFirstTime={true}>
                    <div className={classes.root}>
                        <Quick params={objectivesList} />
                    </div>
                </DashboardLayout>
            </div>
        );
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired
};

export default compose(withStyles(styles), withTranslation())(Dashboard);
